import React, { Component } from 'react';
import '../../styles/row.scss';
import { PlayerInfo } from '../../index';
import { Player } from 'src/mundial/requests/interfaces';
interface IRowProps {
    height: string;
    type: string;
    forward?: boolean;
    player: Player;
    classNameMovePlayer: string;
    idPlayerPosition: number;
    sizePlayers: number;
}

export default class Row extends Component<IRowProps> {
    height: string;
    type: string;
    zone: string;
    style: {
        height: string;
    };
    forward?: boolean;
    classNameMovePlayer: string;
    idPlayerPosition: number;
    sizePlayers: number;

    constructor(props: IRowProps) {
        super(props);
        this.height = this.props.height;
        this.type = this.props.type;
        this.forward = this.props.forward;
        this.style = {
            height: this.height,
        };
        this.idPlayerPosition = this.props.idPlayerPosition;
        this.sizePlayers = this.props.sizePlayers;

        this.classNameMovePlayer = this.props.classNameMovePlayer || '';
        this.getClassNameMovePlayer = this.getClassNameMovePlayer.bind(this);
    }

    getClassNameMovePlayer(): string {
        if (this.idPlayerPosition === 1 && this.sizePlayers === 3)
            return `${this.classNameMovePlayer}-set-back-${this.idPlayerPosition}`;
        else if (this.idPlayerPosition === 0 && this.sizePlayers === 1)
            return `${this.classNameMovePlayer}-set-forward-${this.idPlayerPosition}`;
        else return `${this.classNameMovePlayer || ''}-${this.idPlayerPosition}`;
    }

    render() {
        const {
            player: { lastname = '', uniformNumber = '' },
        } = this.props;
        return (
            <div id="rowFormation" className={`row-${this.type}`} style={this.style}>
                <PlayerInfo
                    type={this.type}
                    forward={this.forward}
                    lastName={lastname}
                    uniformNumber={uniformNumber}
                    classNameMovePlayer={this.getClassNameMovePlayer()}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/GridPositions/Row.tsx